import { Route, Routes, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import "./App.css";
import Header from "./components/Header";
import Navbar from "./components/Navbar";
import AboutUs from "./view/AboutUs";
import Projects from "./view/Projects";
import Services from "./view/Services";
import Clients from "./view/Clients";
import Contact from "./view/Contact";
import Home from "./view/Home";
import ProjectGallery from "./data/ProjectGaller";
import Loader from "./components/Loader";
import ScrollToHashElement from "./components/ScrollToHashElement";
import Footer from "./view/Footer";
import CallButton from "./view/CallButton";

function App() {
  const [loading, setLoading] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setLoading(true);
    const timer = setTimeout(() => setLoading(false), 600);
    return () => clearTimeout(timer);
  }, [location]);

  return (
    <div>
      {loading && <Loader />} 

        {location.pathname === "/" && <Header />}   
        <Navbar />
      <ScrollToHashElement/>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/service" element={<Services />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/projects/:projectId" element={<ProjectGallery />} />
        <Route path="/clients" element={ <Clients/> } />
        <Route path="/contact" element={<Contact />} />
      </Routes>
      <CallButton/>
      <Footer/>
    </div>
  );
}

export default App;
